import { createAction, props } from '@ngrx/store';

export const updateHeight = createAction('[Properties Component] Height updated', props<{ height: number }>());
export const updateWidth = createAction('[Properties Component] Width updated', props<{ width: number }>());
export const updateDimension = createAction('[Properties Component] Height and Width updated', props<any>());
export const setZoneStatus = createAction('[Properties Component] Zone toggled', props<{value?: boolean}>());
export const reset = createAction('[Properties Component] Reset');